import React, { useEffect, useState } from 'react';

import { Alert, Box, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';

import PageSubheader from '~/components/Common/Elements/PageSubheader';
import Spinner from '~/components/Common/Spinner';

import { useGetDepartureDataFeed } from '~/hooks/apis/cruises/useGetDepartureDataFeed';

import { Dayjs, getDayJs } from '~/services/TimeService';

type Props = {
  sailingId: string;
  cruiseType: string;
  onDataFeedAvailabilityChange: (isAvailable: boolean) => void;
};

export default function SailingDataFeed({ sailingId, cruiseType, onDataFeedAvailabilityChange }: Props) {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const date = selectedDate?.format('YYYY-MM-DD');

  const { data: dataFeed, isError, isLoading } = useGetDepartureDataFeed(sailingId, cruiseType, date);

  useEffect(() => {
    if (isLoading) {
      onDataFeedAvailabilityChange(false);
      return;
    }

    onDataFeedAvailabilityChange(!!dataFeed);
  }, [dataFeed, isLoading, onDataFeedAvailabilityChange]);

  return (
    <Box mt={4}>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <PageSubheader title="Last Ingestion Sailing Data" />

        <DatePicker
          label="Ingestion date"
          value={selectedDate}
          onChange={setSelectedDate}
          maxDate={getDayJs().subtract(1, 'day')}
          format="DD/MM/YYYY"
          slotProps={{
            field: { clearable: true },
            textField: { size: 'small' },
          }}
        />
      </Stack>

      {isLoading && (
        <Box mt={3}>
          <Spinner size={24} />
        </Box>
      )}

      {isError && (
        <Box mt={3}>
          <Alert severity="warning">No data feed found for the selected date.</Alert>
        </Box>
      )}

      {!!dataFeed && (
        <Box
          sx={{
            mt: 3,
            overflow: 'auto',
            maxHeight: '700px',
          }}
        >
          <pre>{JSON.stringify(dataFeed, null, 2)}</pre>
        </Box>
      )}
    </Box>
  );
}
